import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  onClick: () => void;
};

export const StartDiagnosisButton: FC<Props> = ({ onClick }) => {
  return <Wrapper onClick={() => onClick()}>無料診断を始める</Wrapper>;
};

const Wrapper = styled.button`
  height: 50px;
  border: 4px solid #fff;
  border-radius: 25px;
  background: #61bfd4;
  font-size: 23px;
  line-height: 42px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
  max-width: 530px;
  width: calc(100% - 40px);

  &:hover {
    box-shadow: none;
  }
`;
